module.exports = __webpack_public_path__ + "img/fifa_banner.752bfc66.png";